// Community Notification Management APIs

/**
 * @function ApiClient#AddNotification
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} HouseHoldList
 * @param {any} Message
 * @param {any} Files
 * @param {any} options = {}
 */
export async function AddNotification(cid, HouseHoldList, Message, Files, options = {}) {
  const formData = new FormData();
  formData.set("Household", JSON.stringify(HouseHoldList));

  if (Message) formData.set("Message", Message);

  if (Files) {
    Files.forEach((file) => {
      formData.append("Files", file);
    });
  }

  return await this._post(`/community/${cid}/notification`, formData, options);
}

/**
 * @function ApiClient#GetNotificationList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} options = {}
 */
export async function GetNotificationList(cid, { sortBy, sortDesc, page, itemsPerPage, startDate, endDate }, options = {}) {
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";

  return await this._get(
    `/community/${cid}/notification_list?&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}`,
    options,
  );
}

/**
 * @function ApiClient#NotificationUnreadNotifyAgain
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} nid
 * @param {any} options = {}
 */
export async function NotificationUnreadNotifyAgain(cid, nid, options = {}) {
  return await this._post(`/community/${cid}/notification_unread_notify_again/${nid}`, null, options);
}
